import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/actividades_entrega/actividades_entrega';
import Listar from './Listar';


const ms2p = (state) => {
  return {
    ...state.actividades_entrega,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Listar);
